import React from "react";
import { useNavigate } from "react-router-dom";
import { TypeOfApplicationEnum } from "../../../utils/enum";
import moment from "moment";
import { dashboardNavConfig } from "../LabGridRow";
import { NotifyType } from "../../../utils/app-config";
import { notify } from "../../../utils";
const LabResultGridRow = (data: any, sno: number) => {
  const navigate = useNavigate();
  const { message } = notify();
  const formatDescription = (description: string) => {
    return description.replace(/<i>/g, "<em>").replace(/<\/i>/g, "</em>");
  };

  const navToSamples = (
    appNum: string,
    typeOfApp: string,
    purposeCode?: string,
    rowId?: number
  ) => {
    if (!purposeCode) {
      message(NotifyType.Error, "Purpose code is Empty");
      return;
    }

    navigate(
      `/${dashboardNavConfig[purposeCode]}?an=${appNum}&type=${typeOfApp}${
        rowId !== undefined ? `&rowId=${rowId}` : ""
      }`
    );
  };
  return (
    <tr>
      <td>{data?.sno || ""}</td>
      <td>{data?.data?.purposeCode || ""}</td>
      <td>{data?.data?.applicationNumber || ""}</td>

      <td
        dangerouslySetInnerHTML={{
          __html: formatDescription(data?.data?.testDescription),
        }}
      ></td>
      <td>{moment(data?.data?.applicationDate).format("DD/MM/yyyy")}</td>
      <td>
        {!data?.data?.isAcknowledged && (
          <button
            onClick={() =>
              navToSamples(
                data?.data?.applicationNumber,
                TypeOfApplicationEnum.Acknowledge,
                data?.data?.purposeCode,
                data?.data?.testRowId
              )
            }
            type="button"
            className="amendment"
          >
            Acknowledge
          </button>
        )}

        {data?.data?.isAcknowledged && (
          <button
            onClick={() =>
              navToSamples(
                data?.data?.applicationNumber,
                TypeOfApplicationEnum.submitresult,
                data?.data?.purposeCode,
                data?.data?.testRowId
              )
            }
            type="button"
            className="amendment"
          >
            Submit Result
          </button>
        )}
      </td>
    </tr>
  );
};

export default LabResultGridRow;
